export default __webpack_public_path__ + "static/4-705509855555f333a9ebd70a43602d73.png";